/**
 * Artiz Theme – Premium Cart JS
 * Handles: quantity +/-, remove item, live price update via Shopify AJAX Cart API
 */

(function() {
  'use strict';

  const CART_API = '/cart/change.js';
  const loading  = document.getElementById('ArtizCartLoading');

  function showLoading() { loading && loading.classList.add('is-active'); }
  function hideLoading() { loading && loading.classList.remove('is-active'); }

  /**
   * Call Shopify Cart API to update quantity
   */
  async function updateItem(line, quantity) {
    showLoading();
    try {
      await window.Artiz.Cart.update(line, quantity);
      reloadPage();
    } catch (e) {
      console.error('[ArtizCart]', e);
      hideLoading();
    }
  }

  /** Full page reload to refresh Liquid-rendered totals and items */
  function reloadPage() {
    window.location.reload();
  }

  /** Delegate events on the items container */
  function init() {
    const form = document.getElementById('ArtizCartForm');
    if (!form) return;

    form.addEventListener('click', function(e) {
      // Minus button
      const minusBtn = e.target.closest('.artiz-cart-page__qty-btn--minus');
      if (minusBtn) {
        const index = parseInt(minusBtn.dataset.index, 10);
        const input = form.querySelector(`.artiz-cart-page__qty-input[data-index="${index}"]`);
        const current = parseInt(input.value, 10);
        const newQty  = Math.max(0, current - 1);
        if (newQty !== current) updateItem(index, newQty);
        return;
      }

      // Plus button
      const plusBtn = e.target.closest('.artiz-cart-page__qty-btn--plus');
      if (plusBtn) {
        const index = parseInt(plusBtn.dataset.index, 10);
        const input = form.querySelector(`.artiz-cart-page__qty-input[data-index="${index}"]`);
        const current = parseInt(input.value, 10);
        updateItem(index, current + 1);
        return;
      }

      // Remove button
      const removeBtn = e.target.closest('.artiz-cart-page__remove-btn');
      if (removeBtn) {
        const index = parseInt(removeBtn.dataset.index, 10);
        updateItem(index, 0);
        return;
      }
    });

    // Manual input change
    form.addEventListener('change', function(e) {
      if (!e.target.classList.contains('artiz-cart-page__qty-input')) return;
      const index = parseInt(e.target.dataset.index, 10);
      const qty   = Math.max(0, parseInt(e.target.value, 10) || 0);
      updateItem(index, qty);
    });

    // Shipping Calculator Logic
    const countrySelect = document.getElementById('AddressCountry');
    const provinceSelect = document.getElementById('AddressProvince');
    const provinceContainer = document.getElementById('AddressProvinceContainer');
    const calcBtn = document.querySelector('.artiz-cart-page__shipping-calc-btn');
    const resultsArea = document.getElementById('ShippingRatesResults');

    if (countrySelect) {
      countrySelect.addEventListener('change', function() {
        const selected = countrySelect.options[countrySelect.selectedIndex];
        const provinces = JSON.parse(selected.getAttribute('data-provinces') || '[]');
        
        if (provinces.length > 0) {
          provinceSelect.innerHTML = '';
          provinces.forEach(([val, label]) => {
            const opt = document.createElement('option');
            opt.value = val;
            opt.textContent = label;
            provinceSelect.appendChild(opt);
          });
          provinceContainer.style.display = 'block';
        } else {
          provinceContainer.style.display = 'none';
          provinceSelect.innerHTML = '';
        }
      });
      
      // Set default values if any
      const defaultCountry = countrySelect.getAttribute('data-default');
      if (defaultCountry) countrySelect.value = defaultCountry;
      countrySelect.dispatchEvent(new Event('change'));
      
      const defaultProvince = provinceSelect.getAttribute('data-default');
      if (defaultProvince) provinceSelect.value = defaultProvince;
    }

    if (calcBtn) {
      calcBtn.addEventListener('click', async function() {
        const country = countrySelect.value;
        const province = provinceSelect.value || '';
        const zip = document.getElementById('AddressZip').value || '';
        
        resultsArea.innerHTML = '<div style="margin-top:10px;color:#888;">' + (window.Artiz.strings ? window.Artiz.strings.shippingCalculating : 'Calculating rates...') + '</div>';
        
        try {
          // Shopify AJAX API for shipping rates
          const query = `shipping_address[country]=${encodeURIComponent(country)}&shipping_address[province]=${encodeURIComponent(province)}&shipping_address[zip]=${encodeURIComponent(zip)}`;
          const response = await fetch(`${window.Shopify.routes.root}cart/shipping_rates.json?${query}`);
          const data = await response.json();
          
          if (data.shipping_rates && data.shipping_rates.length > 0) {
            let html = '<div style="margin-top:15px; border-top:1px solid #eee; padding-top:15px;">';
            data.shipping_rates.forEach(rate => {
              // Usually rate.price is a string like "10.00"
              const price = typeof formatMoney === 'function' ? formatMoney(parseFloat(rate.price) * 100) : `${rate.price} ${rate.currency}`;
              html += `<div style="display:flex; justify-content:space-between; margin-bottom:8px; font-size:0.95rem;">
                <span style="font-weight:600;">${rate.name}</span>
                <span style="color:#111;">${price}</span>
              </div>`;
            });
            html += '</div>';
            resultsArea.innerHTML = html;
          } else {
            resultsArea.innerHTML = '<div style="margin-top:10px;color:#e53e3e;">No shipping rates found for this address.</div>';
          }
        } catch (e) {
          console.error('[ArtizShipping]', e);
          resultsArea.innerHTML = '<div style="margin-top:10px;color:#e53e3e;">Error calculating rates. Please try again.</div>';
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
